import React, {useEffect, useState} from 'react';
import '../styles/App.css';
import "../styles/Partner.css";
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import {Link, useLocation, useSearchParams} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {fetchPartnerData, getPath} from "../utils/functions";

function PartnersPage() {
    const [t] = useTranslation();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [partnersData, setPartnersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [availableCategories, setAvailableCategories] = useState([]);
    const [AllCategory, setAllCategory] = useState("All");

    // Language-sensitive setup
    useEffect(() => {
        const newAllCategory = location.pathname.startsWith("/hk") ? "所有" : "All";
        setAllCategory(newAllCategory);

        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";

        // Fetch categories
        fetch(`https://backend.activikid.hk/api/categories?populate=*&locale=${lang}`)
            .then(response => response.json())
            .then(data => {
                const strapiCategories = data.data.map(item => item.attributes.category);
                setAvailableCategories([...strapiCategories]);
            })
            .catch(console.error);

    }, [location.pathname]);

    // Category selection state
    const initialCategory = searchParams.get("category") || AllCategory;
    const [selectedCategory, setSelectedCategory] = useState(initialCategory);

    // Update category when URL changes
    useEffect(() => {
        const paramCategory = searchParams.get("category") || AllCategory;
        setSelectedCategory(paramCategory);
    }, [searchParams, AllCategory]);

    // Fetch partners data
    useEffect(() => {
        let isMounted = true;
        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";

        const loadData = async () => {
            try {
                const data = await fetchPartnerData(lang);
                if (isMounted) {
                    setPartnersData(data);
                }
            } catch (error) {
                console.error('Error loading partners data:', error);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadData();
        return () => { isMounted = false; };
    }, [location.pathname]);
    console.log(partnersData);

    // Filter partners by selected category
    const filteredPartners = partnersData.filter(partner =>
        selectedCategory === AllCategory ? true : partner.category === selectedCategory
    );

    // Category click handler
    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setSearchParams({ category: category === AllCategory ? "" : category });
    };

    return (
        <>
            <Navbar />
            <div className="partner-page container">
                <div className="partner-text container">
                    <h1 className="partner-page-title">{t('partners_page.title')}</h1>
                    <h2 className="partner-page-subtitle">{t('partners_page.subtitle')}</h2>
                </div>

                {/* Categories Bar */}
                <div className="all-partner-categories">
                    <ul className="partner-categories list-inline">
                        {availableCategories.map((category, index) => (
                            <li key={index} className="list-inline-item">
                                <Link
                                    to={`/partners?category=${encodeURIComponent(category)}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleCategoryClick(category);
                                    }}
                                    className={`category-link ${category === selectedCategory ? "cat-active" : ""}`}
                                >
                                    {category}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <hr style={{color: "rgba(0,0,0,0.7)", marginTop: "0"}}/>

                {/* Partners Grid */}
                <div className="row partner-grid justify-content-start">
                    {filteredPartners.map((partner) => (
                        <div
                            className="col-6 col-sm-4 col-md-3 col-lg-2 partner-card"
                            key={partner.id}
                        >
                            <Link to={getPath(`/partners/${partner.name.toLowerCase().split(" ").join("-")}`)}
                                  className="partner-card-link">
                                <div className="partner-card-img-container">
                                    <img src={partner.image}
                                         alt={partner.name}
                                         className="partner-card-img"/>
                                </div>
                                <h4 className="partner-card-name">{partner.name}</h4>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default PartnersPage;